/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-about-us.jpg";
import flags from "assets/images/about-flags.png";

function AboutUs() {
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar
          routes={routes}
          action={{
            type: "external",
            route: "https://www.creative-tim.com/product/material-kit-react",
            label: "free download",
            color: "info",
          }}
        />
      </MKBox>
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              شرکت توکای ایران
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              هر آنچه که درباره شرکت توکای ایران باید بدانید
            </MKTypography>
            <MKTypography variant="h6" color="white" mt={8} mb={1}>
              ما را دنبال کنید
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-facebook" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-instagram" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-twitter" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#">
                <i className="fab fa-google-plus" />
              </MKTypography>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={{ xs: 3, md: 12 }}>
          <Container>
            <Grid container alignItems="center">
              <Grid item xs={12} lg={5}>
                <MKTypography variant="h3" my={1}>
                  درباره ما بیشتر بدانید
                </MKTypography>
                <MKTypography variant="body2" color="text" mb={2} textAlign="justify">
                  شرکت اپتیک توکای در سال 1939 با هدف تولید عدسی های اپتیکی با استفاده از آخرین
                  فناوری های روز تأسیس شد. در همین راستا، شرکت توکای بخش تحقیق و توسعۀ خود را راه
                  اندازی کرد تا به طور ویژه به حوزۀ بینایی بپردازد. برای پاسخگویی به نیازهای بازار
                  که دائماً در حال تغییرند، شرکت توکای دامنۀ وسیعی از محصولات سفارشی، طراحی های
                  منحصر به فرد و پوشش‌های پیشرفته ای را در طول این سال ها تولید و توسعه داده است. با
                  توجه به تولید انبوه شرکت که در راستای توسعۀ پایدار می باشد، گواهینامه ISO14001 کسب
                  شده است. توکای یکی از تولیدکنندگان برجستۀ عدسی های ارگانیک است که در جهان به کیفیت
                  بالای محصولاتش شناخته می‌شود. موفقیت‌های شرکت توکای با تلاش جمعـی به دست آمده است
                  و محصـولات آن به بیـش از 52 کشور در سراسر اروپا، آسیا، آمریکا، آفریقا و استرالیا
                  صادر می‌شود. عدسی هایی با کیفیت بالا که هر یک از آن ها نشان دهندۀ شعار شرکت است :
                </MKTypography>
                <MKTypography
                  variant="body2"
                  color="info"
                  fontWeight="regular"
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  “ خـاص بودن را تجربـه کنید. ”
                </MKTypography>
              </Grid>
              <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
                <MKBox
                  component="img"
                  src={flags}
                  alt="Tokai Flag"
                  borderRadius="lg"
                  width="100%"
                  position="relative"
                  zIndex={1}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <Timeline
          sx={{
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 0.2,
            },
          }}
        >
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">1939</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>تاسیس توکای اُپتیک در ژاپن توسط آقای شیزو فوروزاوا.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">1982</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>راه اندازی واحد تولیدی جدید در Hina-Cho.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">1990</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>راه‌اندازی کارخانه جدید در شهر اُکازاکی.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">1992</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              تاسیس شرکت توکای اُپتکس با سرمایه‌گذاری مشترک ژاپن و بلژیک.
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2004</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              انتصاب آقای کورت لوریدان به‌عنوان مدیرعامل شرکت توکای اُپتکس بلژیک
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2005</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              شروع به کار شرکت توکای به عنوان تنها تولیدکنندۀ عدسی های فری فرم در بلژیک.
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2006</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              راه‌اندازی تنها خط تولید ایندکس 1.76 برای اولین بار جهان.
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2009</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              آقای هیروکازو فوروزاوا به‌عنوان مدیرعامل شرکت اپتیک توکای، انتخاب شد. توسعه اولین عدسی
              های تدریجی بر پایه علم مغز و اعصاب: RESONAS
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2010</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>افتتاح دفتر شرکت توکای در چین.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2014</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>افتتاح دفتر شرکت توکای در ایتالیا.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2015</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>راه‌اندازی eYE CARE DESIGN و عدسی‌های لوتینا.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2016</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>افتتاح دفتر شرکت توکای در انگلیس.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2019</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>افتتاح دفتر شرکت توکای در استرالیا.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2020</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>افتتاح دفتر شرکت توکای در امارات.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">2021</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
            </TimelineSeparator>
            <TimelineContent>
              انتخاب شرکت اپتیک اعتماد به‌عنوان نمایندۀ انحصاری توکای در ایران.
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
